export default class Fbx {	
	//解析FBX获取相机数据
	static parse(text) {
		let unit1       = parseFloat(/"UnitScaleFactor", "double", ["Number", ]*"",([0-9\.]*)\n/.exec(text)[1]); //缩放单位1
		let unit2       = parseFloat(/"OriginalUnitScaleFactor", "double", ["Number", ]*"",([0-9\.]*)\n/.exec(text)[1]); //缩放单位2
		let unit		= unit2 / 100;// / unit2 / 1000;
		let UpAxis      = parseInt(/"UpAxis", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);               //向上的轴
		let UpSign      = parseInt(/"UpAxisSign", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);           //向上的轴的符号
		let FrontAxis   = parseInt(/"FrontAxis", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);            //向前的轴
		let FrontSign   = parseInt(/"FrontAxisSign", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);        //向前的轴的符号
		let CoordAxis   = parseInt(/"CoordAxis", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);            //向右的轴
		let CoordSign   = parseInt(/"CoordAxisSign", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);        //向右的轴的符号
		let OriginAxis  = parseInt(/"OriginalUpAxis", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);       //向右的轴
		let OriginSign  = parseInt(/"OriginalUpAxisSign", "int", ["Integer", ]*"",(.*)\n/.exec(text)[1]);   //向右的轴的符号
		let camera_reg  = /"Model::([^\"]*)", "[a-zA-Z0-9\-_]*" {[^\}]*P[roperty]*: "Lcl Translation", "Lcl Translation", ["", ]*"A\+?",([Ee\-0-9\.]*),([Ee\-0-9\.]*),([Ee\-0-9\.]*)\r?\n[\t]*P[roperty]*: "Lcl Rotation", "Lcl Rotation", ["", ]*"A\+?",([Ee\-0-9\.]*),([Ee\-0-9\.]*),([Ee\-0-9\.]*)\r?\n/g;

		let cameras     = []; //相机数据
		let camera;
	
		//匹配所有相机数据
		while( camera = camera_reg.exec(text))
		{
			let o = 0;
			cameras.push({
				name : camera[1],
				position : {
					x : Number((camera[2 + CoordAxis] * CoordSign * unit).toFixed(2)),
					y : Number((camera[2 + UpAxis] * UpSign * unit).toFixed(2)),
					z : Number((camera[2 + FrontAxis] * FrontSign * unit).toFixed(2))
				},
				rotate : {
					x : Number((camera[5 + CoordAxis] * CoordSign).toFixed(2)),
					y : Number((camera[5 + UpAxis] * UpSign).toFixed(2)),
					z : Number((camera[5 + FrontAxis] * FrontSign).toFixed(2))
				}
			})
		}
		
		return cameras;
	}	
	
	static async load(file){
		let response = await fetch(file);
		let text	 = await response.text();
		
		return Fbx.parse(text);
	}
}